/* @flow */

import { TAG_ID } from 'src/shared/app/base/api/apiConstant';
import type { ApiListResult } from 'src/shared/app/base/api/type/apiQueryType';
type InfiniteLoadingSettings = {
  tagType: string,
  idGetter: (any) => number,
};

export const getQueryTag = (
  type: string,
  ids: ?Array<number> | number | string,
) => {
  if (ids) {
    if (Array.isArray(ids)) {
      return [
        ...ids.map((id) => ({
          type,
          id,
        })),
        { type, id: TAG_ID.LIST },
      ];
    }
    return [{ type, id: ids }];
  }
  return [type];
};

export const infiniteLoadingSettings = <T>({
  tagType,
  idGetter,
}: InfiniteLoadingSettings) => ({
  // Do not serialize page=1 as it is the default page
  // and we want to share the same cache if we don't specify the page
  serializeQueryArgs: ({
    queryArgs: { page, ...others } = { page: 1 },
  }: {
    queryArgs: Object,
  }) => (page > 1 ? { ...others, page } : others),

  providesTags: (result: ApiListResult<T>) =>
    result
      ? getQueryTag(
          tagType,
          result.results.map((item) => idGetter(item)),
        )
      : getQueryTag(tagType, TAG_ID.LIST),
});
